export default "__VITE_ASSET__DOUg30gE__";